<template>
  <div class="bg-white p-2 border">
    <RedirectUriFilter :filters="filters">
      <template #default>
        <h2 class="h5">
          {{ i18n('Redirect URIs') }}
          <span class="small text-muted">({{ redirectUris.length }})</span>
        </h2>
      </template>
      <template #buttons>
        <RedirectUriCreateAction @created="reload" v-if="application?.acl?.update === true"
          btnClass="ms-1 btn btn-sm btn-outline-dark" :application="application" />
      </template>
    </RedirectUriFilter>

    <RedirectUriList :redirectUris="redirectUris" :loading="loading" @deleted="reload" @updating="loading = true"
      @updated="reload" :application="application" />
  </div>
</template>

<script>
import api from "@/api.js";
import {
  duplicate,
  flattenUrlObject,
} from "@/tools/object.js";
import RedirectUriCreateAction from "@/components/redirectUri/RedirectUriCreateAction.vue";
import RedirectUriFilter from "@/components/redirectUri/RedirectUriFilter.vue";
import RedirectUriList from "@/components/redirectUri/RedirectUriList.vue";

export default {
  components: {
    RedirectUriCreateAction,
    RedirectUriFilter,
    RedirectUriList,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      redirectUris: [],
      filters: {},
      loadTimeout: null,
      loading: true,
    }
  },
  mounted() {
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!this.can('APPLICATION_MANAGE')
        && !this.can('APPLICATION_ACCESS')) {
        this.$router.push({
          name: 'Index',
        });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  computed: {
    params() {
      let params = duplicate(this.filters);
      params.acl = 'redirectUri';

      flattenUrlObject(params);

      return params;
    },
  },
  methods: {
    load(force) {
      clearTimeout(this.loadTimeout);
      this.loading = true;

      if (!force) {
        this.loadTimeout = setTimeout(() => {
          this.load(true);
        }, 250);
        return;
      }

      api.get(`applications/${this.application.id}/redirectUris`, this.params).then(redirectUris => {
        this.redirectUris = redirectUris;
        this.loading = false;
      });
    },
    reload() {
      this.load();
    },
  },
};
</script>